import { API_BASE_URL } from "@/config";
import { format_business_registration_number } from "@/utils/validations.js";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'CIPCVerificationForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                registration_number: '',
            }
        };
    },
    emits: ['service_status_complete'],
    methods: {
        format_registration_number(event) {
            const { formatted_input, new_cursor_position } = format_business_registration_number(event);

            // Update the registration number model
            this.form.registration_number = formatted_input;

            // Adjust the cursor position
            this.$nextTick(() => {
                event.target.selectionStart = new_cursor_position;
                event.target.selectionEnd = new_cursor_position;
            });
        },
        handle_submit() {
            if (!this.form.registration_number) {
                let error_message = 'Please enter a company registration number';
                $('.error-message').text(error_message).removeClass('d-none');
                setTimeout(() => {
                    $('.error-message').text('').addClass('d-none');
                }, 3000);
                return;
            }

            const string_fields = ['registration_number'];
            for (const field of string_fields) {
                if (typeof this.form[field] !== 'string' || !this.form[field].trim()) {
                    let error_message = `Invalid input for ${field.replace('_', ' ')}. Please enter a valid string.`;
                    $('.error-message').text(error_message).removeClass('d-none');
                    setTimeout(() => {
                        $('.error-message').text('').addClass('d-none');
                    }, 3000);
                    return;
                }
            }

            const TOKEN = localStorage.getItem('token');
            const CIPC_API = `${API_BASE_URL}/verify_api/instant_verify_api/company_information/`;

            this.error = '';

            $.ajax({
                url: CIPC_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    company_registration_number: this.form.registration_number,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });
                },
                success: (response) => {
                    Swal.close();
                    let status = response.status;
                    let message = response.data;

                    if (status === 'success') {
                        this.showSuccess('Successful', 'Company information retrieved successfully', 3000);
                        this.$emit('service_status_complete');
                        this.form.registration_number = '';

                    } else if (status === 'error') {
                        try {
                            if (message && message.includes('An error occurred on CIPC Verification: No record found')) {
                                message = 'Please enter a valid company registration number'
                            }
                        } catch (e) {
                            message = 'An error occurred';
                        }
                        $('.error-message').text(message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    }
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Error verifying company';

                    if (error.responseJSON) {
                        if (error.responseJSON.message) {
                            error_message = error.responseJSON.message;
                        }
                        $('.error-message').text(error_message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    } else {
                        $('.error-message').text(error_message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    }
                }
            });
        }
    }
};
